// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"H6-z","upvoteIcon":"I6-z","downvoteIcon":"J6-z","feedbackIcon":"K6-z"};